import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Bulb = (props) => (
  <Icon viewBox="0 0 39.6 75.7" {...props}>
    <g>
      <defs>
        <path id="a" d="M0 0h39.6v75.7H0z" />
      </defs>
      <clipPath id="b">
        <use overflow="visible" xlinkHref="#a" />
      </clipPath>
      <path fill="none" stroke="currentColor" d="M19.9 13.2V0" clipPath="url(#b)" strokeWidth="3" strokeLinejoin="round" strokeMiterlimit="10" />
      <path fill="none" stroke="currentColor" d="M28.8 14.3l3.4-6M11 14.3l-3.4-6" strokeWidth="3" strokeLinejoin="round" strokeMiterlimit="10" />
      <g>
        <defs>
          <path id="c" d="M0 0h39.6v75.7H0z" />
        </defs>
        <clipPath id="d">
          <use overflow="visible" xlinkHref="#c" />
        </clipPath>
        <path fill="none" stroke="currentColor" d="M28.2 35c1 1 1.1 2.5 0 3.6-1.4 1.4-4.5.9-4.5.9s-.5-3.1.9-4.5c1.1-1.1 2.6-1 3.6 0zM11.6 35c-1 1-1.1 2.5 0 3.6 1.4 1.4 4.5.9 4.5.9s.5-3.1-.9-4.5c-1.1-1.1-2.6-1-3.6 0z"
          clipPath="url(#d)" strokeLinejoin="round" strokeMiterlimit="10" />
        <path fill="none" stroke="currentColor" d="M10.1 60.9H29M10.1 64.8H29M10.1 68.8H29" clipPath="url(#d)" strokeMiterlimit="10" />
        <path fill="none" stroke="currentColor" d="M19.8 74.2c1.6 0 6.1-2.2 8.6-3.5.5-.3.8-.8.8-1.4v-8.4c0-7 8.9-11.3 8.9-23.4 0-10.1-8.2-18.3-18.3-18.3S1.5 27.4 1.5 37.5c0 12.2 8.9 16.4 8.9 23.4v8.4c0 .6.3 1.1.8 1.4 2.5 1.3 7 3.5 8.6 3.5z"
          clipPath="url(#d)" strokeWidth="3" strokeLinejoin="round" strokeMiterlimit="10" />
        <path fill="none" stroke="currentColor" d="M17.8 60.9L16 39.5M22 60.9l1.8-21.4M23.8 39.5H16" clipPath="url(#d)" strokeLinejoin="round" strokeMiterlimit="10"
        />
      </g>
    </g>
  </Icon>
);
/*eslint-enable */

export default Bulb;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Bulb.js